import React from "react";
import { Radio, Shield, ChevronRight, Loader2 } from "lucide-react";
import { getResources } from "../../lib/api";

const SERVICE_COLOR = { Police: "#5B9BFF", Traffic: "#FFC726", Fire: "#FF5C7A", Ambulance: "#22E0A1", "Coast Guard": "#38BDF8" };

const FieldLogin = ({ onSelect }) => {
  const [units, setUnits] = React.useState(null);
  React.useEffect(() => { getResources().then((r) => setUnits(r.units)).catch(() => setUnits([])); }, []);

  return (
    <div className="go-scroll min-h-screen overflow-y-auto px-5 pb-10 pt-[max(env(safe-area-inset-top),28px)]">
      <div className="mb-6 flex flex-col items-center text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#1E4DB7] ring-1 ring-white/15" style={{ boxShadow: "0 10px 30px rgba(30,77,183,0.4)" }}>
          <Radio size={30} color="#FFC726" strokeWidth={2.2} />
        </div>
        <h1 className="font-head mt-4 text-2xl font-extrabold text-white">Field Command</h1>
        <p className="mt-1 text-sm text-[#8194B2]">Select your unit to go on duty</p>
      </div>

      {!units && <div className="flex justify-center py-16 text-[#67799A]"><Loader2 className="animate-spin" /></div>}

      <div className="space-y-2.5">
        {(units || []).map((u) => {
          const col = SERVICE_COLOR[u.service] || "#5B9BFF";
          return (
            <button key={u.id} onClick={() => onSelect(u)} className="go-card flex w-full items-center gap-3.5 rounded-2xl px-4 py-3.5 text-left transition-transform active:scale-[0.98]" data-testid={`login-unit-${u.id}`}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-head text-sm font-extrabold" style={{ background: `${col}22`, color: col }}>{u.callsign?.[0] || "U"}</span>
              <div className="min-w-0 flex-1">
                <div className="font-head text-[15px] font-bold text-white">{u.callsign} <span className="text-xs font-medium text-[#67799A]">· {u.service}</span></div>
                <div className="truncate text-xs text-[#8194B2]">{u.station}</div>
              </div>
              <ChevronRight size={18} className="text-[#3E4E6B]" />
            </button>
          );
        })}
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 text-xs text-[#4F6180]"><Shield size={13} /> Government of Barbados · Restricted C2 Access</div>
    </div>
  );
};

export default FieldLogin;
